module.exports = __webpack_public_path__ + "img/bbva.6944ebea.jpg";